<template>
  <section class="co-bg-striped">
    <div class="co-container-md px-4 py-20">
      <div class="te-webdesing-merit-sub-title text-center font-bold text-co-primary-400">
        学ぶだけじゃない
      </div>
      <h2 class="co-heading-2">
        副業や転職に繋がる実績作り<br class="block sm:hidden">
      </h2>
      <div class="mt-12 flex flex-col justify-between sm:flex-row">
        <img
          class="te-merit-image"
          src="~/assets/images/Te/TeCourse/Webdesign/Merit/merit-banner.png"
          alt="Merit"
        >
        <div class="te-merit-positon">
          <div class="mb-0 text-right sm:mb-3 md:mb-5 md:text-center lg:mb-10">
            <h3
              class="te-merit-title mb-0 inline-block px-5 py-2 font-bold text-co-gray-50 sm:block lg:px-8 lg:py-3"
              style="background-color: #cdbf49"
            >
              バナーの実案件で実績作り
            </h3>
          </div>
          <p class="te-merit-text mb-0 bg-white px-4 py-3 leading-loose text-co-gray-600">
            学んだ成果をバナーの実案件制作で発揮しましょう。3案件のご依頼を保証いたします。実務実績があれば、その後のお仕事の獲得がスムーズになります。報酬のお支払いもございます。
          </p>
        </div>
      </div>
      <div class="mt-10 flex flex-col justify-between sm:flex-row-reverse md:mt-8">
        <img
          class="te-merit-image"
          src="~/assets/images/Te/TeCourse/Webdesign/Merit/merit-portfolio.png"
          alt="Merit"
        >
        <div class="te-merit-positon te-right">
          <div class="mb-0 text-left sm:mb-3 md:mb-5 lg:mb-10">
            <h3
              class="te-merit-title mb-0 inline-block px-5 py-2 font-bold text-co-gray-50 sm:block lg:px-8 lg:py-3"
              style="background-color: #cdbf49"
            >
              ポートフォリオサイトの作成
            </h3>
          </div>
          <p class="te-merit-text mb-0 bg-co-gray-50 px-4 py-3 leading-loose text-co-gray-600">
            ポートフォリオサイトは、自身のスキルやクリエイティブ力を効果的に伝え、仕事を獲得するための重要なツールです。最終課題にて素敵なポートフォリオ制作をサポートいたします。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-webdesing-merit-sub-title {
  font-size: 1.25rem;
    @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

.te-merit-positon {
  margin-top: -1.25rem;
  @media (min-width: 576px) {
    margin-top: 0.75rem;
    margin-left: -3.25rem;
  }
  @media (min-width: 768px) {
    width: 26rem;
    margin-top: 1.25rem;
    margin-left: -7.5rem;
  }
  @media (min-width: 992px) {
    width: 30rem;
    margin-top: 2rem;
    margin-left: -12.5rem;
  }
}

.te-merit-positon.te-right {
  @media (min-width: 576px) {
    z-index: 2;
    margin-right: -3.25rem;
    margin-left: 0;
  }
  @media (min-width: 768px) {
    margin-right: -7.5rem;
  }
  @media (min-width: 992px) {
    margin-right: -12.5rem;
  }
}

.te-merit-image {
  width: 20.25rem;
  height: 14.5625rem;
  @media (min-width: 768px) {
    width: 30rem;
    height: 21.5625rem;
  }
  @media (min-width: 992px) {
    width: 37.5rem;
    height: 26.9375rem;
  }
}

.te-merit-title {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
  @media (min-width: 992px) {
    font-size: 2rem;
  }
}

.te-merit-text {
  font-size: 0.875rem;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
  @media (min-width: 992px) {
    font-size: 1.25rem;
  }
}
</style>
